import { render, staticRenderFns } from "./EmailEditor.vue?vue&type=template&id=4f62711c&"
import script from "./EmailEditor.vue?vue&type=script&lang=ts&"
export * from "./EmailEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports